import React from 'react'
import { Table, Button, Tooltip, Input, Icon, Checkbox, Divider, DatePicker, notification } from 'antd'
import API from '../services/API'
import Segment from './Segment'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { currencyFormat } from '../services/Utils'
import { FilePdfOutline, FileExcelOutline } from '@ant-design/icons'
import StatusColumnFilter from './TableFilters/StatusColumnFilter'
import DateColumnFilter from './TableFilters/DateColumnFilter'
import DefaultColumnFilter from './TableFilters/DefaultColumnFilter'
import { filter } from 'lodash'

const { RangePicker } = DatePicker

const TableLayout = ({
    columns = [],
    title = '',
    resource = '',
    params = '',
    actions = [],
    additionalAction = null,
    additionalActionHeader = null,
    actionUrl = { create: '', edit: '', show: '' },
    additionalFilter,
    onChange, // se agrega para recalcular el reporte de ventas y credito.
    shouldValidateParams = false, // para que no entre e en el useEffect de los parametros
    handleLoading = (isLoading) => {},
}) => {
    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState([])
    const [active, setActive] = React.useState(true)
    const [pagination, setPagination] = React.useState({})
    const [query, setQuery] = React.useState('')
    const [currentColumns, setCurrentColumns] = React.useState([])
    const [currentTableFilters, setCurrenTableFilters] = React.useState(null)
    const refInput = React.useRef(null)


    const getData = ({ page = 1, filters = null, sorter = null }) => {
        if(currentTableFilters){
            filters = currentTableFilters.filters
        }

        let newQuery = '';
        if (filters) {
            const keys = Object.keys(filters)
            keys.forEach(k => {
                if (filters[k].length) {
                    newQuery += `&filter[${k}]=${filters[k][0]}`
                }
            })
        }
        if (sorter && Object.keys(sorter).length) {
            const order = sorter.order === 'descend' ? '-' : ''
            newQuery += `&sort=${order}${sorter.field}`
        }
        if(!sorter){
            if (onChange) {
                onChange(true, newQuery);
            }
        }
        console.log('resource',`/api/${resource}?per_page=10&page=${page}${params}${newQuery}`)
        setLoading(true);
        API.get(`/api/${resource}?per_page=10&page=${page}${params}${newQuery}`)
            .then(response => {
                console.log(response.data, page, "pagination")
                setLoading(false)
                setQuery(newQuery)
                setData(response.data.data || response.data.payload)
                setPagination(response.data);

            })
            .catch((error) => {
                console.error(error);
                setLoading(false)
            }).finally(() => {
                setLoading(false)
            })
    }

    // tell parent container data fetch is done
    React.useEffect(() => {
        handleLoading(loading)
    }, [loading])

    React.useEffect(() => {
        const filters = {}
        if (actions.includes('active')) {
            filters.active = [active]
        }
        if (!shouldValidateParams) {
            // evita validar los parametro de la url
            getData({ page: 1, filters: filters, sorter: null })
        }
    }, [params])

    // Filtrar
   React.useEffect(() => {
    console.log('currentTableFilters',currentTableFilters);
        if (currentTableFilters !== null) {
            getData(currentTableFilters);
        }
    }, [currentTableFilters]);

    React.useEffect(() => {
        const newColumns = [...columns].map(item => {
            if (item.dataIndex === 'created_at' || item.dataIndex === 'updated_at' || item.dataType === 'date') {
                item.render = (label, record) => {
                    return label ? moment(label).format('DD/MM/YYYY') : ''
                }
            }
            if (item.dataType === 'money') {
                item.render = (label, record) => {
                    return label ? currencyFormat(label) : ''
                }
            }
            if (item.dataIndex === 'actions') {
                item.filtered = false
                item.render = (label, record) => {
                    return (
                        <div style={{ display: 'flex', flexWrap: 'nowrap', flex: 1, justifyContent: 'center' }}>
                            {actions.includes('edit') ? (
                                <Tooltip title="Editar" placement="top">
                                    <Link to={
                                        actionUrl && actionUrl.edit
                                        ? actionUrl.edit +
                                          '/' +
                                          record.id
                                        : `/${resource}/edit/${record.id}`
                                    } style={{ marginLeft: '5px' }}>
                                        <Button type="primary" shape="circle" icon="edit" />
                                    </Link>
                                </Tooltip>
                            ) : null}
                            <Tooltip title="Detalles" placement="top">
                                {actions.includes('show') ? (
                                    <Link to={
                                        actionUrl && actionUrl.show
												? actionUrl.show +
												  '/' +
												  record.id
												: `/${resource}/show/${record.id}`
                                    } style={{ marginLeft: '5px' }}>
                                        <Button type="primary" shape="circle" icon="eye" />
                                    </Link>
                                ) : null}
                                {/* {actions.includes('pay') ? (
                                    <Link to={`/${resource}/show/${record.id}`} style={{ marginLeft: '5px' }}>
                                        <Button type="primary" shape="cash" icon="eye" />
                                    </Link>
                                ) : null} */}
                            </Tooltip>
                            {additionalAction ? additionalAction(record) : null}
                        </div>
                    )
                }
            }

            if (item.filtered) {
                item.filterIcon = filtered => (
                    <Icon
                        type="search"
                        onClick={() => {
                            console.log('some')
                        }}
                        style={{ color: filtered ? '#1890ff' : undefined }}
                    />
                )
                item.filterDropdown = ({
					setSelectedKeys,
					selectedKeys,
					confirm,
					clearFilters,
				}) => {
                    let filterInput
					if (
						item.dataIndex === 'created_at' ||
						item.dataIndex === 'updated_at' ||
						item.dataType === 'date'
					) {
                        filterInput = (
                            <DateColumnFilter
								setSelectedKeys={setSelectedKeys}
								selectedKeys={selectedKeys}
								confirm={confirm}
								refInput={refInput}
							/>
                        // <DatePicker
                        // style={{ width: 200, marginBottom: 10, display: 'block' }}
                        // value={selectedKeys[0]}
                        // ref={node => {
                        //     refInput.current = node
                        // }}
                        // placeholder="Buscar"
                        // onChange={date => {
                        //     setSelectedKeys(date ? [date] : [])
                        // }}
                        // format="DD/MM/YYYY"
                        // onPressEnter={() => {
                        //     confirm()
                        // }}
                    ///>
                    )
                    }else if (
                        item.dataIndex === 'status' ||
						item.dataIndex === 'humanizedStatus' ||
						item.dataIndex === 'status_id' ||
                        item.dataType === 'status'
                    ) {
                        filterInput = (
							<StatusColumnFilter
								setSelectedKeys={setSelectedKeys}
								selectedKeys={selectedKeys}
								confirm={confirm}
								route={`/api/status/${resource}`}
								refInput={refInput}
							/>)
                    }else {
                        filterInput = (
                            <DefaultColumnFilter
								setSelectedKeys={setSelectedKeys}
								selectedKeys={selectedKeys}
								confirm={confirm}
								refInput={refInput}
							/>
                        //    <Input
                        //     placeholder="Buscar"
                        //     ref={node => {
                        //         refInput.current = node
                        //     }}
                        //     focus
                        //     value={selectedKeys[0]}
                        //     onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        //     onPressEnter={() => {
                        //         confirm()
                        //     }}
                        //     style={{ width: 200, marginBottom: 10, display: 'block' }}
                     // />
                    )
                    }
                    return (
						<div style={{ padding: 8 }}>
							{filterInput}
							<Button
								onClick={() => {
									clearFilters()
									setSelectedKeys([])
								}}
								size="small"
								style={{ width: 95, marginRight: 5 }}
							>
								Cancelar
							</Button>
							<Button
								type="primary"
								onClick={() => {
									confirm()
								}}
								size="small"
								style={{ width: 95, marginLeft: 5 }}
							>
								Buscar
							</Button>
						</div>
					)
                }
                item.onFilterDropdownVisibleChange = visible => {
                    if (visible) {
						setTimeout(() => {
							if (refInput.current && refInput.current.input) {
								refInput.current.input.focus()
							}
						}, 0)
					}
                }
            }

            return item
        })

        setCurrentColumns(newColumns)
    }, [])

    const handleTableChange = (pagination, filters, sorter) => {
        // eslint-disable-next-line react/no-access-state-in-setstate
        const pager = { ...pagination }
        pager.current = pagination.current
        setLoading(true)
        setPagination(pager)
        if (actions.includes('active')) {
            filters.active = [active]
        }
        setCurrenTableFilters({
            page: pagination.current,
            filters,
            sorter
        });
    //    getData({
    //         page: pagination.current,
    //         filters,
    //         sorter,
    //     })
    }
    return (
        <Segment>
            <Divider className="title">
                {title} {!active ? '(inactivos)' : ''}
            </Divider>

            <div className="ant-header-button">
                {additionalActionHeader ? additionalActionHeader : null}

                {actions.includes('active') ? (
                    <div style={{ margin: '0px 10px' }}>
                        <Checkbox
                            checked={active}
                            onChange={e => {
                                const newActive = e.target.checked ? 1 : 0
                                setActive(newActive)
                                getData({ page: 0, filters: { active: [newActive] } })
                            }}
                        >
                            Registros activos
                        </Checkbox>
                    </div>
                ) : null}
                {actions.includes('pdf') ? (
                    <Tooltip title="Generar archivo en PDF" placement="top">
                        <Button
                            style={{ marginRight: '10px' }}
                            type="primary"
                            shape="circle"
                            icon={'file-pdf'}
                            onClick={() => {
                               const newResource = resource === 'v2/order'? 'orders' : resource;
                                window.location.href = `/api/pdf?table=${newResource}&pagination=false&json=false${query}${params}`

                                // if (pagination.total > 1000) {
                                //     notification.error({
                                //         message: 'La cantidad de registros exceede el limite.',
                                //     })
                                // } else {
                                //     window.location.href = `/api/pdf?table=${resource}&pagination=false&json=false${query}${params}`
                                // }
                            }}
                        />
                    </Tooltip>
                ) : null}

                {actions.includes('excel') ? (
                    <Tooltip title="Generar hoja de calculo" placement="top">
                        <Button
                            style={{ marginRight: '10px' }}
                            type="primary"
                            shape="circle"
                            icon={'file-excel'}
                            onClick={() => {
                                const newResource = resource === 'v2/order'? 'orders' : resource;
                                window.location.href = `/api/excel?table=${newResource}&pagination=false&json=false${query}${params}`
                                // if (pagination.total > 1000) {
                                //     notification.error({
                                //         message: 'La cantidad de registros exceede el limite.',
                                //     })
                                // } else {
                                //     window.location.href = `/api/excel?table=${resource}&pagination=false&json=false${query}${params}`
                                // }
                            }}
                        />
                    </Tooltip>
                ) : null}

                {actions.includes('create') ? (
                    <Tooltip title="Crear" placement="top">
                        <Link to={
                            		actionUrl && actionUrl.create
									? actionUrl.create
									: `/${resource}/create`
                        }>
                            <Button type="primary" shape="circle" icon="plus" />
                        </Link>
                    </Tooltip>
                ) : null}
            </div>
            {/* Valida si una funcion se pasada como parametro y la ejecuta, si no es una funcion, la imprime como un componente.
              Se utiliza en reporte de ventas y ventas a credito para ejecutar la funcion de geData */}
            {typeof additionalFilter === 'function' ? (
                <div className="ant-filter">{additionalFilter(getData)}</div>
            ) : additionalFilter ? (
                <div className="ant-filter">{additionalFilter}</div>
            ) : null}
            <div className="table-container">
                <Table
                    dataSource={data}
                    columns={currentColumns}
                    rowKey={record => record.id}
                    pagination={pagination}
                    loading={loading}
                    onChange={handleTableChange}
                    bordered
                    size="small"
                />
            </div>
        </Segment>
    )
}

export default TableLayout
